import React from 'react';
import styled, { css } from 'styled-components';

const MenuContainer = styled.ul`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  margin: ${({ theme }) => theme.spacingBase};
  border: 2px solid ${({ theme }) => theme.colors.outline};
  ${({ dropdown }) => {
    if (dropdown) {
      return css`
        position: relative;
        margin-top: -50px;
        border-radius: 10px;

        &:before {
          content: '';
          display: block;
          position: absolute;
          right: 48px;
          bottom: 100%;
          width: 0;
          height: 0;
          border: 10px solid transparent;
          border-bottom-color: ${({ theme }) => theme.colors.outline};
        }

        &:after {
          content: '';
          display: block;
          position: absolute;
          right: 50px;
          bottom: 100%;
          width: 0;
          height: 0;
          border: 8px solid transparent;
          border-bottom-color: white;
        }
      `;
    }
  }}
`;

const MenuListItem = styled.li`
  flex: 1 1;
`;

export default function Menu({ children, dropdown }) {
  return (
    <MenuContainer dropdown={dropdown}>
      {children.map((child, index) => (
        <MenuListItem key={index}>{child}</MenuListItem>
      ))}
    </MenuContainer>
  );
}
